import { useState } from "react";
import {
  BrandsSVG,
  ContactSVG,
  MenSVG,
  PrivacySVG,
  TermsAndConditionsSVG,
  WomenSVG,
  InviteFriendsSVG,
} from "./svgsMobile";
import NavigationLinks from "./ProfileDrawer/NavigationLinks";
import BottomTray from "./Trays/BottomTray";
import InviteToLookflock from "./Trays/InviteToLookflock";

const ProfileDrawer = () => {
  const [isOpen, setIsOpen] = useState();
  return (
    <>
      <div
        className="offcanvas offcanvasFromLeft px-0"
        style={{ width: "100vw", top: 0, left: 0, zIndex: 1052 }}
        tabIndex="-1"
        id="offcanvasProfileDrawer"
        tabindex="-1"
        aria-labelledby="offcanvasProfileDrawerLabel"
      >
        <style jsx>
          {`
            .textColor {
              color: #676a79;
            }
            .offcanvasFromLeft {
              transform: translateX(-100%);
            }
          `}
        </style>
        <div className="offcanvas-body p-0">
          {/* Header */}
          <div
            className="d-flex align-items-center justify-content-start w-100 border-bottom bg-white"
            style={{
              gap: "6px",
              padding: "0.75rem 1rem",
              position: "sticky",
              top: "0rem",
              zIndex: 1,
            }}
          >
            <svg
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 6L16.17 16.17"
                stroke="#667085"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 16.17L16.17 6"
                stroke="#667085"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div
              style={{
                fontFamily: "Nunito Sans",
                fontWeight: "600",
                fontSize: "24px",
                lineHeight: "100%",
                letterSpacing: "0%",
                textAlign: "center",
                fontStyle: "italic",
              }}
            >
              lookflock
            </div>
          </div>
          {/* Body */}
          <div
            className="d-flex flex-column"
            style={{ padding: "10px 0px 0px", gap: "24px" }}
          >
            {/* Body */}
            <div className="d-flex flex-column" style={{ gap: "10px" }}>
              <div style={{ padding: "6px 1rem" }}>
                <div
                  style={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    color: "black",
                  }}
                >
                  For You
                </div>
              </div>
              <div className="d-flex flex-column" style={{ gap: "8px" }}>
                <div
                  onClick={() => {
                    document.body.style.overflow = "";
                    setIsOpen(true);
                  }}
                >
                  <NavigationLinks
                    SVG={InviteFriendsSVG}
                    text="Invite Friends"
                    route={`#`}
                  />
                </div>
                <NavigationLinks
                  SVG={BrandsSVG}
                  text="Brands"
                  route={`/brands`}
                />
                <NavigationLinks SVG={MenSVG} text="Men" route={`/Men`} />
                <NavigationLinks SVG={WomenSVG} text="Women" route={`/Women`} />
              </div>
            </div>
            <div className="d-flex flex-column" style={{ gap: "10px" }}>
              <div style={{ padding: "6px 1rem" }}>
                <div
                  style={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    color: "black",
                  }}
                >
                  Settings
                </div>
              </div>
              <div className="d-flex flex-column" style={{ gap: "8px" }}>
                <NavigationLinks
                  SVG={ContactSVG}
                  text="Contact Us"
                  route="/staticPages/contactUs"
                />
                <NavigationLinks
                  SVG={PrivacySVG}
                  text="Privacy Policy"
                  route="/staticPages/privacyPolicy"
                />
                <NavigationLinks
                  SVG={TermsAndConditionsSVG}
                  text="Terms of Service"
                  route="/staticPages/termsAndConditions"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <BottomTray
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        text={"Invite to Lookflock"}
      >
        <InviteToLookflock />
      </BottomTray>
    </>
  );
};

export default ProfileDrawer;
